// M2V.io - Main Entry Point
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

import App from './App.vue'
import router from './router'
import { initLocale } from './i18n'

// Global styles
import './styles/variables.css'

// Initialize locale from storage
initLocale()

// Initialize theme from storage
const savedTheme = localStorage.getItem('m2v_theme') || 'dark'
document.documentElement.setAttribute('data-theme', savedTheme)

// Create app
const app = createApp(App)

// Use plugins
app.use(createPinia())
app.use(router)
app.use(ElementPlus)

// Mount
app.mount('#app')
